import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface NomeFavoritoModalData {
  nomeInicial: string;
}

@Component({
  selector: 'app-nome-favorito-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './nome-favorito-modal.component.html',
  styleUrl: './nome-favorito-modal.component.css',
})
export class NomeFavoritoModalComponent {
  public form = this.fb.group({
    nome: [this.data.nomeInicial || '', [Validators.required, Validators.maxLength(120)]],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: NomeFavoritoModalData,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<NomeFavoritoModalComponent>
  ) {}

  public confirmar(): void {
    const nome = this.form.controls.nome.value?.trim();
    if (!nome) {
      this.form.controls.nome.markAsTouched();
      return;
    }

    this.dialogRef.close(nome);
  }
}
